import React, { useState, ReactNode, Children } from 'react';

interface ElementCardGroupProps {
  title: string;
  children: ReactNode;
}

const ElementCardGroup = ({ title, children }: ElementCardGroupProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="from-above">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`card-group-ext ${isOpen ? 'card-group-open' : 'card-group-closed'} linear-bouncer-text`}>
        {isOpen ? `▼ ${title}` : `▶ ${title}`}
      </button>
      {isOpen && <div>{Children.map(children, (child) => child)}</div>}
    </div>
  );
};

export default ElementCardGroup;
